var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStandardBlocks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128.000000pt",
    height: "128.000000pt",
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M605 1080 l-29 -30 64 0 64 0 -29 30 c-16 17 -32 30 -35 30 -3 0 -19 -13 -35 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330 1017 c-30 -16 -51 -37 -67 -67 -22 -42 -23 -51 -23 -310 0 -259 1 -268 23 -310 16 -30 37 -51 67 -67 42 -22 51 -23 310 -23 259 0 268 1 310 23 30 16 51 37 67 67 22 42 23 51 23 310 0 259 -1 268 -23 310 -16 30 -37 51 -67 67 -42 22 -51 23 -310 23 -259 0 -268 -1 -310 -23z m282 -324 l28 -27 28 27 c51 49 74 26 25 -25 l-27 -28 27 -28 c49 -51 26 -74 -25 -25 l-28 27 -28 -27 c-15 -15 -33 -27 -40 -27 -20 0 -14 22 15 52 l27 28 -27 28 c-49 51 -26 74 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 670 l-29 -30 32 -33 32 -32 0 63 c0 34 -1 62 -3 62 -2 0 -16 -14 -32 -30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050 640 l0 -65 32 33 33 32 -33 32 -32 33 0 -65z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608 198 l32 -33 32 33 33 32 -65 0 -65 0 33 -32z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardBlocks);
export default __webpack_public_path__ + "static/media/StandardBlocks.7f23238e37e73a82534b1451fb9001fe.svg";
export { ForwardRef as ReactComponent };